import styled from 'styled-components';

import { IOcAppTheme } from '../../config/ocTheme';
import { disabledBehavior } from '../Shared/ButtonDisabledBehavior.styled';
import { overlayInteraction } from '../Shared/ButtonOverlay.styled';

export const StyledButton = styled.button<{ $disabled?: boolean, $outlineOnHover?: boolean }>`
  padding: 4px 16px;
  border: none;
  border-radius: 4px;

  background-color: ${({ theme }) => (theme as IOcAppTheme).color.buttonBG || theme.color.chatPanelBG};
  color: ${({ theme }) => (theme as IOcAppTheme).color.buttonText || theme.color.chatPanel};
  font-size: ${({ theme }) => theme.font.size.default};

  ${disabledBehavior()}

  ${overlayInteraction({ 
    isHighlighted: (theme) => (theme as IOcAppTheme).color.buttonBG 
      ? !!(theme as IOcAppTheme).color.highlightOnButtonBG 
      : !!(theme as IOcAppTheme).color.highlightOnChatPanelBG, 
    backgroundColor: (theme) => (theme as IOcAppTheme).color.buttonBG || theme.color.chatPanelBG })}
`;